import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pla-cherished-number-plates',
  templateUrl: './cherished-number-plates.component.html',
  styleUrls: ['./cherished-number-plates.component.scss']
})
export class CherishedNumberPlatesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
